import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { TimeSeriesChartService } from '../time-series-charts.service';

@Component({
  selector: 'add-time-series-chart',
  templateUrl: './add-time-series-chart.component.html',
  styleUrls: ['./add-time-series-chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddTimeSeriesChartComponent implements OnInit {
  public addTimeSeriesChartForm: UntypedFormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<AddTimeSeriesChartComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _timeSeriesChartService: TimeSeriesChartService,
  ) {}

  ngOnInit(): void {
    this.addTimeSeriesChartForm = this._formBuilder.group({
      title: ['', [Validators.required]],
      related_to_type: ['Project'],
    });

    this.addTimeSeriesChartForm.patchValue(this.data);
  }

  discard(): void {
    this.matDialogRef.close();
  }

  save(): void {
    const vals = this.addTimeSeriesChartForm.value;
    this._timeSeriesChartService.saveTimeSeriesChart(vals).subscribe((timeSeriesChart) => {
      this.discard();
    });
  }
}
